import Aos from "aos";
import { useEffect } from "react";

const BankvoleCTABanner = () => {
  useEffect(() => {
        Aos.init({
            duration: 1000,
        });
    }, []);
  return (
    <section className="bv-cta" id="bv-cta">
      <div className="bv-cta-inner" data-aos="fade-down" data-aos-duration="1000">
        <h2 className="bv-cta-title">Start planning today.</h2>
        <p className="bv-cta-text">
          Grow your money with confidence and stay on track towards your
          financial goals.
        </p>
        <p className="bv-cta-label">Download Bankvole now</p>
        <div className="bv-store-buttons--center" data-aos="zoom-in"data-aos-delay="200">
          <a
            href="https://apps.apple.com/ng/app/bankvole/id6478485232"
            target="_blank"
            rel="noreferrer"
            className="bv-store-btn"
          >
            <img
              src={`${process.env.PUBLIC_URL}/assets/icons/app-store-badge.png`}
              alt="Download on the App Store"
            />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.bankvole.app"
            target="_blank"
            rel="noreferrer"
            className="bv-store-btn"
          >
            <img
              src={`${process.env.PUBLIC_URL}/assets/icons/google-play-badge.png`}
              alt="Get it on Google Play"
            />
          </a>
        </div>
      </div>
    </section>
  );
};

export default BankvoleCTABanner;
